import { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import ConditionalPreloader from "../components/preloader/Preloaders";
import Profile from "../components/profile/Profile";
import ServerDeadView from "../components/startView/ServerDeadView";
import StartViewNew from "../components/startView/StartViewNew";
import SuspendedAccountView from "../components/startView/SuspendedAccountView";
import Monitor from "../components/status/Monitor";
import { IAppState } from "../redux/types";
import { StorageHelper } from "../utils/StorageHelper";
import { history } from "./BrowserHistory";
import { ProtectedRoute, PublicRoute, SavedRoute } from "./Routes";
import SocketBroken from "../components/modals/SocketBroken";
import { useTranslation } from "react-i18next";

export const RootRoute = (): JSX.Element => {
  const { i18n } = useTranslation();
  const { isAuthorized, isAuthenticated } = useSelector(
    (state: IAppState) => state.auth
  );
  const isError = useSelector(
    (state: IAppState) => state.healthCheck.organizationServiceError
  );
  const { socketsWorking } = useSelector(
    (state: IAppState) => state.healthCheck
  );

  const { language } = useSelector((state: IAppState) => state.userProfile);

  const { id } = useSelector((state: IAppState) => state.userProfile);
  let previousPage = StorageHelper.instance.GetPage(id);
  if (previousPage === undefined) previousPage = "/monitor";
  const authRedirect: string = isAuthenticated
    ? isError
      ? "/error"
      : previousPage
    : "/login";
  const defaultRedirect: string = previousPage;

  useEffect(() => {
    if (socketsWorking === false) {
      history.push("/notification");
    } else {
      history.push("/monitor");
    }
  }, [socketsWorking, isAuthorized, isAuthenticated]);

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    } else {
      process.env.EXT_SHORT === "cn"
        ? i18n.changeLanguage("zh")
        : i18n.changeLanguage("en");
    }
  }, [language]);

  return (
    <Router history={history}>
      <Switch>
        <PublicRoute name="startView" path="/login" isAuthorized={isAuthorized}>
          <StartViewNew />
        </PublicRoute>
        <PublicRoute name="suspend" path="/suspend" isAuthorized={isAuthorized}>
          <SuspendedAccountView />
        </PublicRoute>
        <ProtectedRoute isAuthorized={isAuthorized}>
          <Switch>
            <Route path="/error" exact>
              <Suspense fallback={<ConditionalPreloader />}>
                <ServerDeadView />
              </Suspense>
            </Route>
            <Switch>
              <SavedRoute path="/monitor">
                <Suspense fallback={<ConditionalPreloader />}>
                  <Monitor />
                </Suspense>
              </SavedRoute>
              <SavedRoute path="/profile">
                <Suspense fallback={<ConditionalPreloader />}>
                  <Profile />
                </Suspense>
              </SavedRoute>
              <Route path="/notification" exact>
                <Suspense fallback={<ConditionalPreloader />}>
                  <SocketBroken />
                </Suspense>
              </Route>
              <Redirect path="/" to={defaultRedirect} />
            </Switch>
          </Switch>
        </ProtectedRoute>
        <Redirect exact path="/" to={authRedirect} />
      </Switch>
    </Router>
  );
};
